import { api } from '@/lib/api';

export const usersService = {
  async getAll() {
    const { data } = await api.get('/users');
    return { data };
  },

  async getById(id) {
    const { data } = await api.get(`/users/${id}`);
    return { data };
  },

  async create(userData) {
    const { data } = await api.post('/users', userData);
    return { data };
  },

  async update(id, userData) {
    const { data } = await api.patch(`/users/${id}`, userData);
    return { data };
  },

  async delete(id) {
    await api.delete(`/users/${id}`);
    return { success: true };
  },

  async getRoles() {
    const { data } = await api.get('/users/roles');
    return { data };
  },
};
